import Clients from '@/views/clients/views/Clients.vue';
import ClientsPayments from '@/views/clients/views/ClientsPayments.vue';
import UserStatistics from '@/views/clients/views/UserStatistics.vue';

export default [
  {
    path: '/clients/clients/',
    component: Clients,
    //component: () => import('@/views/clients/views/Clients.vue'),
    meta: { 
      requiresPermission: 'clients.view', 
      //requiresSubscription: 'clients',
      featureName: 'Clients'
    } 
    //meta: { requiresPermission: 'clients'} 
  },
  {
    path: '/clients/clients_payments/',
    component: ClientsPayments,
    meta: { 
      requiresPermission: 'clients_payments.view', 
      //requiresSubscription: 'clients_payments.view', 
      featureName: 'Clients Payments'
    } 
    //component: () => import('@/views/clients/views/Clients.vue'),
    //meta: { requiresPermission: 'clients_payments.view', requiresSubscription: 'clients_payments.view' } 
    
  },
  { 
    path: '/clients/user_statistics/', 
    component: UserStatistics,
    //component: () => import('../views/clients/UserStatistics.vue'), 
    meta: { 
      requiresPermission: 'user_statistics.view', 
      //requiresSubscription: 'user_statistics.view', 
      featureName: 'User Statistics'
    } 
  },
];